import { useSelector } from 'react-redux'

import { Account } from '@/core/api/entities/account/account'
import { useAuth } from '@/core/hooks/useAuth'
import { RootState } from '@/core/store'

/**
 * Hook to get the current active account
 * Returns the selected account if one is selected, otherwise falls back to the user's account
 *
 * @returns The current active account (selected or user's account) or null if none exists
 *
 * @example
 * ```typescript
 * const account = useCurrentAccount()
 * if (account) {
 *   console.log(account.name)
 * }
 * ```
 */
export const useCurrentAccount = (): Account | null | undefined => {
	const { user } = useAuth()
	const selectedAccount = useSelector(
		(state: RootState) => state.selectedAccount.selectedAccount
	)

	return selectedAccount || user?.account
}
